// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariSearch from '@/pages/mercari-search/components/_MercariSearch.vue'

hybridPage()

createApp({
	name: 'Mercari Index Page',
	components: {
		MercariSearch,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariIndex)

		const { mercariSearchPageContent } = window.pageContent

		return {
			mercariSearchPageContent,
		}
	},
}).mount('#bsMain')
